import { formatSnakeValue } from 'src/lib/formatters'

export enum EquipmentClass {
  TRACTOR_SLEEPER_CAB = 'TRACTOR_SLEEPER_CAB',
  TRACTOR_DAY_CAB = 'TRACTOR_DAY_CAB',
  STRAIGHT_TRUCK = 'STRAIGHT_TRUCK',
  HOTSHOT_PICKUP = 'HOTSHOT_PICKUP',
  OTHER = 'OTHER',
  DRY_VAN = 'DRY_VAN',
  TANKER = 'TANKER',
  DUMP = 'DUMP',
  FLATBED = 'FLATBED',
}

export enum EquipmentType {
  VAN = 'VAN',
  REEFER = 'REEFER',
  TANK = 'TANK',
}

export const selectableEquipmentTypes = [
  { value: EquipmentClass.TRACTOR_SLEEPER_CAB, label: 'Tractor - Sleeper Cab' },
  { value: EquipmentClass.TRACTOR_DAY_CAB, label: 'Tractor - Day Cab' },
  { value: EquipmentClass.STRAIGHT_TRUCK, label: 'Straight Truck' },
  { value: EquipmentClass.HOTSHOT_PICKUP, label: 'Hotshot Pickup' },
  { value: EquipmentClass.OTHER, label: 'Other' },
]

export const buildEquipmentTypeOptions = (
  currentValue?: EquipmentClass | string
) => {
  const hasCurrentValue = selectableEquipmentTypes.some(
    (option) => option.value === currentValue
  )
  const currentLabel = selectableEquipmentTypes.find(
    (option) => option.value === currentValue
  )?.label

  if (currentValue && !hasCurrentValue) {
    return [
      {
        value: currentValue,
        label: currentLabel ?? formatSnakeValue(currentValue),
        disabled: true,
      },
      ...selectableEquipmentTypes,
    ]
  }

  return selectableEquipmentTypes
}
